export default __webpack_public_path__ + "static/media/brainOverviewNotebookFR.57405d63.pdf";